var $f8ed0031472d4b0e$exports = {};
$f8ed0031472d4b0e$exports = {
    "collapse": `\u{417}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`,
    "expand": `\u{420}\u{43E}\u{437}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`
};


export {$f8ed0031472d4b0e$exports as default};
//# sourceMappingURL=uk-UA.module.js.map
